import { render, staticRenderFns } from "./add-transport-vehicle-info-group-modal.vue?vue&type=template&id=2283b6cd&"
import script from "./add-transport-vehicle-info-group-modal.vue?vue&type=script&lang=js&"
export * from "./add-transport-vehicle-info-group-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports